import instance from '../../utils/axios';

class RedAndTransfer {
    async getRedList(staffId,myWechatId,beginTime,endTime,pageIndex,keyword,searchParam) {
        if (beginTime != ''){
            beginTime = beginTime + ' 00:00:00';
        }
        if (endTime != ''){
            endTime = endTime + ' 23:59:59';
        }
        let data = {
            staffId: staffId,
            myWechatId:myWechatId,
            begin:beginTime,
            end:endTime,
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field":"数量","expression":"count(1)"}]',
            dictionaryNames: 'staffId.base_staff',
            sort: 'desc',
            sortField: 'createTime',
            fuzzySearch: keyword,
        }
        _.each(searchParam, function (index, item) {
            data[item] = searchParam[item];
        });
        return await instance.post('/crm/wechat/redPacket/getDetailList', data);
    }
    async getTransferList(staffId,myWechatId,beginTime,endTime,pageIndex,keyword,searchParam) {
        if (beginTime != ''){
            beginTime = beginTime + ' 00:00:00';
        }
        if (endTime != ''){
            endTime = endTime + ' 23:59:59';
        }
        let data = {
            staffId: staffId,
            myWechatId:myWechatId,
            begin:beginTime,
            end:endTime,
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field":"数量","expression":"count(1)"}]',
            dictionaryNames: 'staffId.base_staff',
            sort: 'desc',
            sortField: 'createTime',
            fuzzySearch: keyword,
        }
        _.each(searchParam, function (index, item) {
            data[item] = searchParam[item];
        });
        return await instance.post('/crm/wechat/transfer/getDetailList', data);
    }
}
export default new RedAndTransfer();